import settings from '../settings.js'

import respCalHtml from '../templates/responsive-calendar-tpl.html'

const $inject = []

function ResponsiveCalendar() {
    return {
        restrict: 'EA',
        replace: true,
        templateUrl: respCalHtml,
        link: function(scope, elem, attrs) {
            const today = new Date();

            elem.responsiveCalendar({
                    time: today.getFullYear() + '-' + (today.getMonth() + 1),
                    translateMonths: [_locale('january').ucfirst(), _locale('february').ucfirst(), _locale('march').ucfirst(), _locale('april').ucfirst(), _locale('may').ucfirst(), _locale('june').ucfirst(), _locale('july').ucfirst(), _locale('august').ucfirst(), _locale('september').ucfirst(), _locale('october').ucfirst(), _locale('november').ucfirst(), _locale('december').ucfirst()],
                    startFromSunday: false,
                    monthChangeAnimation: false,
                    onDayClick(e) {
                        const date = $(this).data(),
                            formattedDate = ((date.day < 10) ? '0' + date.day : '' + date.day) + ((date.month < 10) ? '.0' + date.month : '.' + date.month) + '.' + date.year; //Format to DD.MM.YYYY

                        if (typeof scope.deregisterListener !== 'undefined')
                            scope.deregisterListener();

                        scope.calendarPopup.close();
                        scope.calendarPopupResolve(formattedDate);
                    }
            });
        }
    };
}

ResponsiveCalendar.$inject = $inject

export default ResponsiveCalendar